import { useEffect, useState } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import capitalize from 'lodash/capitalize';
import { getAllCards } from 'network/apis/gift-cards';

const mockCardData = {
    createdAt: '2020-05-12T05:04:39+00:00',
    images: {
        small: 'https://giftbig.s3.amazonaws.com/microsite/product/EGCGBAAVG001/d/small_image/2179_microsite.jpg',
        thumbnail:
            'https://giftbig.s3.amazonaws.com/microsite/product/EGCGBAAVG001/d/thumbnail/2179_microsite.jpg',
        mobile: 'https://giftbig.s3.amazonaws.com/microsite/product/EGCGBAAVG001/d/mobile/2179_microsite.jpg',
        base: 'https://giftbig.s3.amazonaws.com/microsite/product/EGCGBAAVG001/d/image/2179_microsite.jpg'
    },
    minPrice: '500',
    name: 'Avast AVG E-Gift Card',
    maxPrice: '3000',
    sku: 'EGCGBAAVG001',
    url: 'avast-avg-e-gift-card',
    relatedProducts: [],
    payout: {
        validate_terms_and_condition: '',
        payment_methods: ['svc'],
        transaction_types: ['IMPS', 'NEFT', 'UPI'],
        account_types: ['BANK_ACCOUNT', 'UPI'],
        convenience_charge: {
            amount: '0',
            maximum_amount: '',
            minimum_amount: '',
            type: 'fixed'
        },
        maximum_beneficiaries: '',
        enabled: true,
        validation: {
            amount: '1',
            convenience_charge: '0'
        }
    },
    description:
        'Avast is a global leader in digital security software products for consumers and businesses. It provides protection (Antivirus), privacy (VPN) and performance products under the Avast and AVG brands.\r\nUsing real-time intelligence from over 400 million Avast users, Avast helps prevent more than 66 million threats every day, to keep people and their devices safe & secure around the world.',
    type: 'DIGITAL',
    themes: [
        {
            image: 'https://stage.woohoo.in/media/catalog/customoptions/best_wishes_thumnail.jpeg',
            pdfImage:
                'https://stage.woohoo.in/media/catalog/customoptions/best_wishes_pdf.jpeg',
            price: '0.0000',
            sku: 'best_wishes',
            emailImage:
                'https://stage.woohoo.in/media/catalog/customoptions/best_wishes_email.jpeg'
        },
        {
            image: 'https://stage.woohoo.in/media/catalog/customoptions/congo_thumnail.jpeg',
            pdfImage:
                'https://stage.woohoo.in/media/catalog/customoptions/congo_pdf.jpeg',
            price: '0.0000',
            sku: 'congo',
            emailImage:
                'https://stage.woohoo.in/media/catalog/customoptions/congo_email.jpeg'
        },
        {
            pdfImage:
                'https://stage.woohoo.in/media/catalog/customoptions/thanku_pdf.jpeg',
            image: 'https://stage.woohoo.in/media/catalog/customoptions/thanku_thumnail.jpeg',
            price: '0.0000',
            sku: 'thanku',
            emailImage:
                'https://stage.woohoo.in/media/catalog/customoptions/thanku_email.jpeg'
        },
        {
            pdfImage:
                'https://stage.woohoo.in/media/catalog/customoptions/wedding_pdf.jpeg',
            image: 'https://stage.woohoo.in/media/catalog/customoptions/wedding_thumnail.jpeg',
            price: '0.0000',
            sku: 'wedding',
            emailImage:
                'https://stage.woohoo.in/media/catalog/customoptions/wedding_email.jpeg'
        },
        {
            image: 'https://stage.woohoo.in/media/catalog/customoptions/valentine_thumnail.jpeg',
            pdfImage:
                'https://stage.woohoo.in/media/catalog/customoptions/valentine_pdf.jpeg',
            price: '0.0000',
            sku: 'valentine',
            emailImage:
                'https://stage.woohoo.in/media/catalog/customoptions/valentine_email.jpeg'
        }
    ],
    schedulingEnabled: false,
    discounts: [],
    price: {
        cpg: [],
        min: '500',
        max: '3000',
        price: 'SLAB',
        denominations: ['500', '1000', '1500', '2000', '2500', '3000'],
        currency: {
            symbol: '₹',
            code: 'INR',
            numericCode: '356'
        },
        type: 'SLAB'
    },
    reloadCardNumber: false,
    categories: [
        '7',
        '8',
        '50',
        '192',
        '276',
        '288',
        '359',
        '607',
        '608',
        '689',
        '690',
        '798'
    ],
    expiry: '90 Days from the date of issue.',
    id: '2179',
    cpg: {
        barcode: {
            encoding: null
        },
        redemptionTerms: []
    },
    brandName: 'Avast AVG',
    etaMessage: '',
    handlingCharges: [],
    additionalForm: null,
    tnc: {
        link: 'https://woohoo.app.link/e/oizAe4N2p6',
        content:
            'This Gift Card is valid for 90 days from the date of activation and can be redeemed only for merchandise on www.avastavg.in<br/>In case, the value of merchandise purchased exceeds the value of the Gift Card, the difference shall be paid by the bearer via payment options on www.avastavg.in <br/>Any balance amount on the used gift card, can be utilized for another purchase within the validity period.<br/>This Gift Card cannot be redeemed, replaced, refunded, revalidated or exchanged for cash. <br/>Protect the Gift Card number and the PIN to avoid misuse.<br/>JRS Investments (on behalf of Avast-AVG) reserves the right to reject a gift card, if any fraudulent act is suspected and shall not assume any liability in case the card PIN gets stolen/compromised.  <br/>JRS Investments (on behalf of Avast-AVG) is the final authority on the interpretation of these Terms & Conditions.<br/>Terms & Conditions are subject to change without notice. Disputes would be subject to exclusive jurisdiction of Mumbai courts only.<br/>For customer support, please email: support@avastavg.in or call: +91 99309 11136'
    },
    kycEnabled: '0',
    customThemesAvailable: false,
    formatExpiry: null,
    metaInformation: {
        meta: {
            keywords: null,
            description: null,
            title: null
        },
        canonical: {
            url: null
        },
        page: {
            title: null
        }
    },
    updated: true,
    storeLocatorUrl: null,
    offer: '2.3',
    redeem: 'Avast is a global leader in digital security software products for consumers and businesses. It provides protection (Antivirus), privacy (VPN) and performance products under the Avast and AVG brands.\nUsing real-time intelligence from over 400 million Avast users, Avast helps prevent more than 66 million threats every day, to keep people and their devices safe & secure around the world.',
    tnc_content:
        'This Gift Card is valid for 90 days from the date of activation and can be redeemed only for merchandise on www.avastavg.in<br/>In case, the value of merchandise purchased exceeds the value of the Gift Card, the difference shall be paid by the bearer via payment options on www.avastavg.in <br/>Any balance amount on the used gift card, can be utilized for another purchase within the validity period.<br/>This Gift Card cannot be redeemed, replaced, refunded, revalidated or exchanged for cash. <br/>Protect the Gift Card number and the PIN to avoid misuse.<br/>JRS Investments (on behalf of Avast-AVG) reserves the right to reject a gift card, if any fraudulent act is suspected and shall not assume any liability in case the card PIN gets stolen/compromised.  <br/>JRS Investments (on behalf of Avast-AVG) is the final authority on the interpretation of these Terms & Conditions.<br/>Terms & Conditions are subject to change without notice. Disputes would be subject to exclusive jurisdiction of Mumbai courts only.<br/>For customer support, please email: support@avastavg.in or call: +91 99309 11136',
    currency: {
        symbol: '₹',
        code: 'INR',
        numericCode: '356'
    },
    tableData: {
        id: 0
    },
    status: 'active',
    MasterGiftCard: 'QwikCilverNonAmazon',
    top_brand: true,
    updatedAt: '2023-02-28T13:19:08+00:00'
};

function UseGcList({ isTopBrands }) {
    const [loading, setLoading] = useState(false);
    const [prevPageFirstDocs, setPrevPageFirstDocs] = useState([]);
    const [search, setSearch] = useState('');
    const [giftCards, setGiftCards] = useState([]);
    const [selectedGc, setSelectedGc] = useState(null);

    useEffect(() => {
        if (!search) {
            fetchGiftCards({ moveTo: 'Next', isReset: true });
        }
    }, [search]);

    function fetchGiftCards({ moveTo, prevPageFirstDoc, isReset }) {
        setLoading(true);
        const role =
            localStorage.getItem('WitchloginAs') ||
            localStorage.getItem('loginAs');
        var EnGiftCards = localStorage.getItem('GiftCards');
        let GiftCardsArray = ['NONE'];
        if (EnGiftCards) {
            GiftCardsArray = EnGiftCards.split(',');
        }
        let payload = {
            StartAt: prevPageFirstDoc,
            search_key: capitalize(search),
            search_by: 'name',
            LastDocument: giftCards?.LastDocument,
            FirstDocument: giftCards?.FirstDocument,
            perPage: 20,
            moveTo: moveTo,
            status: 'active',
            TopBrands: isTopBrands ? 'true' : 'false',
            EnabledGiftCards: GiftCardsArray,
            userRole: role
        };
        
        getAllCards(payload).then((res) => {
            setLoading(false);
            setGiftCards(res.data);
        });
    }

    function onSearchChange(e) {
        setSearch(e.target.value);
    }

    function handleReset() {
        setSearch('');
    }

    function handleSearchClick() {
        fetchGiftCards({ moveTo: false, isReset: true });
    }

    function handleNextClick() {
        setPrevPageFirstDocs((list) => [...list, giftCards?.FirstDocument]);
        fetchGiftCards({ moveTo: 'Next', isReset: false });
    }

    function handlePrevclick() {
        const clonedPrevPageFirstDocs = cloneDeep(prevPageFirstDocs);
        const poppedPageDoc = clonedPrevPageFirstDocs.pop();
        setPrevPageFirstDocs(clonedPrevPageFirstDocs);
        fetchGiftCards({
            moveTo: 'Prev',
            isReset: false,
            prevPageFirstDoc: poppedPageDoc
        });
    }

    return {
        loading,
        search,
        selectedGc,
        giftCards,
        prevPageFirstDocs,
        onSearchChange,
        setSelectedGc,
        handleReset,
        handleSearchClick,
        handleNextClick,
        handlePrevclick
    };
}

export default UseGcList;
